
//import Splide from '@splidejs/splide';

const { Splide } = require("@splidejs/splide")


const { getDateAsInt8,getDate8AsDateObj } = require('../../utils/utils.js');

const French = require("flatpickr/dist/l10n/fr.js").default.fr;
//require("flatpickr/dist/themes/airbnb.css");




//myDropdown.remove();


const layout = {

	init() {

        if(document.querySelector('#date-range-search')){
            const startDateInput =  document.querySelector('#startDate');
            const endDateInput = document.querySelector('#endDate');
            const dateRangeSearch = flatpickr(
                "#date-range-search", 
            {    
                time_24hr: true,
                mode: 'range',
                "locale": French,
                dateFormat: "d/m/Y",
                ariaDateFormat: "d/m/Y",
                showMonths: 1,
                defaultDate: [getDate8AsDateObj(startDateInput.value), getDate8AsDateObj(endDateInput.value)],
                onReady: function(selectedDates,dateStr, instance){
                    formatCustomDate(selectedDates, dateStr, instance);
                },
                onChange: function(selectedDates,dateStr, instance){
                    setDates();
                    formatCustomDate(selectedDates, dateStr, instance);
                },
                onClose: function(selectedDates, dateStr, instance){
                    if(selectedDates.length == 1) selectedDates[1] = null;
                },
                
            }
            );


            if(document.querySelector('#date-range-search + .clear-date')){
                document.querySelector('#date-range-search + .clear-date').addEventListener('click',function(){
                    dateRangeSearch.clear();
                })
            }
            function setDates(){
                startDateInput.value = dateRangeSearch && dateRangeSearch.selectedDates[0] ? getDateAsInt8(dateRangeSearch.selectedDates[0]) : null;
                endDateInput.value = dateRangeSearch && dateRangeSearch.selectedDates[1] ?  getDateAsInt8(dateRangeSearch.selectedDates[1]) : null;
            }

            function formatCustomDate(selectedDates, dateStr, instance){
                if (selectedDates.length == 1) {
                    instance.element.value = `à partir du ${instance.formatDate(selectedDates[0], "d/m/Y" )}`;
                }
                if (selectedDates.length == 2) {
                    if(getDateAsInt8(selectedDates[0]) == getDateAsInt8(selectedDates[1])){
                        instance.element.value = `Le ${instance.formatDate(selectedDates[0], "d/m/Y" )}`;
                    }else{
                        instance.element.value = `Du ${instance.formatDate(selectedDates[0], "d/m/Y" )} au ${instance.formatDate(selectedDates[1], "d/m/Y" )}`
                    }
                }
            }
        }

       


        let lastScrollY = window.scrollY;

        
        window.onscroll = function(event) {

            if (window.scrollY > 5) {
                header.classList.add("sticky");
            } else {
                header.classList.remove("sticky");
            }


            if (window.scrollY > 300 && window.scrollY > lastScrollY) {
                header.classList.add("hide");
            } else {
                header.classList.remove("hide");
            }

            lastScrollY = window.scrollY;



            //
        };


        document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem){

            everyitem.addEventListener('mouseover', function(e){
    
                let el_link = this.querySelector('a[data-bs-toggle]');
    
                if(el_link != null){
                    let nextEl = el_link.nextElementSibling;
                    el_link.classList.add('show');
                    nextEl.classList.add('show');
                    document.querySelector('header').classList.add('menu-open');
                }
    
            });
            everyitem.addEventListener('mouseleave', function(e){
                let el_link = this.querySelector('a[data-bs-toggle]');
    
                if(el_link != null){
                    let nextEl = el_link.nextElementSibling;
                    el_link.classList.remove('show');
                    nextEl.classList.remove('show');
                    if (document.querySelectorAll(".dropdown-toggle.show").length==0 && document.querySelectorAll("header.no-banner").length==0) document.querySelector('header').classList.remove('menu-open');

                }
    
    
            })
        });
    



        document.getElementById('collapsingNavbar2').addEventListener('show.bs.collapse', function () {
            document.querySelector('header').classList.add('menu-open');
        })


        document.getElementById('collapsingNavbar2').addEventListener('hide.bs.collapse', function () {
            if (document.querySelectorAll(".dropdown-toggle.show").length==0 && document.querySelectorAll("header.no-banner").length==0) document.querySelector('header').classList.remove('menu-open');
        })
          


       // if (/*!document.querySelector("button.hamburger").classList.contains("is-active") &&*/ document.querySelectorAll(".dropdown-toggle.show").length==0 && document.querySelectorAll("header.no-banner").length==0) document.querySelector('header').classList.remove('menu-open');

        


        //collapsingNavbar2

        let dropdowns = document.querySelectorAll(".dropdown-toggle");
        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('show.bs.dropdown', function () {
                document.querySelector('header').classList.add('menu-open');
            })
            dropdown.addEventListener('hidden.bs.dropdown', function () {
                if (!document.querySelector("button.hamburger").classList.contains("is-active") && document.querySelectorAll(".dropdown-toggle.show").length==0 && document.querySelectorAll("header.no-banner").length==0) document.querySelector('header').classList.remove('menu-open');
            })
        });




		const hamburgerButton = document.querySelector("button.hamburger");
        hamburgerButton.addEventListener('click', () => {
            if (hamburgerButton.getAttribute('aria-expanded')==="true") {
                hamburgerButton.classList.add('is-active');
            } else {
                hamburgerButton.classList.remove('is-active');
            }
        })

        let scroll = 0;
        let lastScroll = 0;
        let scrollBuffer = 0;
        const header = document.querySelector('header');


        // window.addEventListener('scroll', function() {
        //     scroll = window.scrollY;
        //     if (this.innerWidth > 991) return header.classList.remove('header-hidden');
            
        //     if (scroll > lastScroll) {
        //         scrollBuffer = (scrollBuffer > 0) ? scrollBuffer + (scroll - lastScroll) : (scroll - lastScroll);
        //         //scrolldown
        //         if(!header.classList.contains('header-hidden') && hamburgerButton.getAttribute('aria-expanded')==="false" && scrollBuffer > 80) header.classList.add('header-hidden')
                
        //     } else {
        //         scrollBuffer = (scrollBuffer < 0) ? scrollBuffer + (scroll - lastScroll) : (scroll - lastScroll);
        //         //scrollup
        //         if(header.classList.contains('header-hidden') && scrollBuffer < -80) header.classList.remove('header-hidden')
        //     }
        //     lastScroll = scroll;

        // });


        if (document.querySelector('#banner .splide')) {
            new Splide( '#banner .splide', {
                type: 'fade',
                speed:1000,
                perPage: 1,
                arrows: false,
                pagination: true,
                autoplay: true,
                interval: 4000, 
                pauseOnHover:false,
                cover: true,
                lazyLoad:'sequential',
                rewind:true,
              } ).mount();
        }

    
        if(document.querySelectorAll('input[type=date].today-min')){
            document.querySelectorAll('input[type=date].today-min').forEach(input => {
                input.setAttribute('min', new Date().toISOString().split('T')[0]);
            })
        }

        if(document.querySelectorAll('input[type=date].today-max')){
            document.querySelectorAll('input[type=date].today-max').forEach(input => {
                input.setAttribute('max', new Date().toISOString().split('T')[0]);
            })
        }

	}
};


module.exports = layout;

